import type { SVGProps } from 'react';

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M3.2562 7.2547C3.596 6.91331 4.14484 6.91538 4.48219 7.25927L11.9634 14.886L19.5237 7.31183C19.864 6.97154 20.413 6.97449 20.7497 7.31868C21.0862 7.66303 21.0829 8.21865 20.7429 8.55953L12.5798 16.737C12.5762 16.7407 12.5733 16.7459 12.5697 16.7496C12.4862 16.8333 12.3899 16.8957 12.2874 16.9381C12.2549 16.9516 12.2206 16.9585 12.187 16.9678C12.0674 17.0008 11.9441 17.0092 11.8223 16.9895C11.7044 16.9705 11.5894 16.9298 11.4859 16.8615C11.4357 16.8283 11.3877 16.7898 11.3437 16.745L3.25168 8.49554C2.91431 8.15163 2.91641 7.59616 3.2562 7.2547Z" />
  </svg>
);
